import Vue from "vue";
import Router from "vue-router";
import { i18n, loadLanguageAsync } from "./i18n";

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: "/",
    component: () => import("./layout/MainLayout.vue"),
    redirect: "/home",
    children: [
      {
        path: "/home",
        name: "home",
        meta: { title: "nav.home" },
        component: () => import("./views/Home/Home.vue"),
      },
      {
        path: "/about",
        name: "about",
        meta: { title: "nav.about" },
        component: () => import("./views/About/About.vue"),
      },
      {
        path: "/investment",
        name: "investment",
        meta: { title: "nav.investment" },
        component: () => import("./views/Investment/Investment.vue"),
      },
      {
        path: "/products",
        name: "products",
        meta: { title: "nav.investment" },
        component: () => import("./views/Products/Products.vue"),
      },
      {
        path: "/news",
        name: "news",
        meta: { title: "nav.news" },
        component: () => import("./views/News/Trends.vue"),
      },
      {
        path: "/news-detail/:id",
        meta: { title: "nav.newsDetail" },
        component: () => import("./views/News/NewsDetail.vue"),
      },
      {
        path: "/strategic",
        name: "strategic",
        meta: { title: "nav.strategic" },
        component: () => import("./views/Strategic/Strategic.vue"),
      },
    ],
  },
  {
    path: "/*",
    redirect: "/home",
  },
];

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const lang = localStorage.getItem("lang");
  if (to.meta.title) {
    document.title = `${i18n.t(to.meta.title)}${
      lang === "en" ? "-Fujian Fulv Lianxin Fund" : "-华闽联信基金"
    }`; // 🔹 获取 i18n 翻译
  }

  if (i18n.locale !== lang) {
    loadLanguageAsync(lang).then(() => next());
  } else {
    next();
  }
});

export default router;
